import { Grid, Group, Skeleton } from '@ingeniorforeningen/figurine-core';

const SkeletonPromotionContent = () => {
  return (
    <>
      <Grid container mb="md" style={{ marginTop: '75px' }}>
        <Grid item sm={7}>
          <Skeleton width="100%" height="96px" mb="md" />
        </Grid>
      </Grid>
      <Group grow spacing="xl">
        <Skeleton height="525px" />
        <Skeleton height="525px" />
        <Skeleton height="525px" />
      </Group>
    </>
  );
};

export default SkeletonPromotionContent;
